"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ItemVariation = _interopRequireDefault(require("../../../organisms/FoodMenu/components/variants/item/ItemVariation"));

var SpecialPriceVariation = function SpecialPriceVariation(_ref) {
  var variations = _ref.variations;
  var variationsStyle = {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: variationsStyle
  }, variations.map(function (_ref2, index) {
    var name = _ref2.name,
        price = _ref2.price;
    return /*#__PURE__*/_react["default"].createElement(_ItemVariation["default"], {
      key: name,
      name: name,
      price: price,
      isOnlyVariation: variations.length === 1,
      isLastVariation: index === variations.length - 1
    });
  }));
};

SpecialPriceVariation.propTypes = {
  variations: _propTypes["default"].array.isRequired
};
var _default = SpecialPriceVariation;
exports["default"] = _default;